module.exports = __webpack_public_path__ + "static/img/FR@3x.755d873b.jpg";